import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface LocateFinishedMessageProps {
  onFinish: () => void;
}

export const LocateFinishedMessage = ({ onFinish }: LocateFinishedMessageProps) => {
  const { t } = useTranslation('receiveModule');

  return (
    <div className="w-full h-full flex items-center justify-center p-8">
      <div className="text-center max-w-md">
        <h3 className="text-success text-xl font-semibold mb-2">
          {t('locate.finished_title', { defaultValue: 'Ubicar finalizado' })}
        </h3>
        <p className="text-complementary-text mb-6">
          {t('locate.finished_message', {
            defaultValue: 'Todos los artículos han sido ubicados',
          })}
        </p>
        <Button variant="primary" onClick={onFinish} data-testid="go-to-returned-button" className="mx-auto">
          {t('ui.back_to_returned', { defaultValue: 'Volver a Rehusados' })}
        </Button>
      </div>
    </div>
  );
};
